import React from "react";

function smcard({ icon, text }) {
  return (
    <div className="sm-card-body">
      <div className="sm-c-icon">
        <img src={icon} width={30} height={30} alt="icon" />
      </div>
      <div className="sm-c-text">
        <h2>{text}</h2>
      </div>
    </div>
  );
}

export default smcard;
